import { useState } from "react";
import { GoogleSignInButton } from "./GoogleSignInButton.tsx";

interface LoginFormProps {
  onSubmit: () => Promise<void>;
  disabled?: boolean;
}

// SSO: no per-app license key entry — login authenticates identity only.
// Authorization for a specific app is checked by that app on the next request.
export function LoginForm({ onSubmit, disabled }: LoginFormProps) {
  const [submitting, setSubmitting] = useState(false);

  async function handleClick(): Promise<void> {
    if (submitting) return;
    setSubmitting(true);
    try {
      await onSubmit();
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <GoogleSignInButton
      onClick={handleClick}
      loading={submitting}
      {...(disabled !== undefined ? { disabled } : {})}
    />
  );
}
